/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getUTCTimeStampMMDDYYYY } from '../../../../../SharedModules/DateUtilities/DateUtilities';
import Grid from '../../../../../SharedModules/Table/TableGridWithFeatures';
import TableFilterHeader from '../../../../contactType/components/TableFilterHeader';
import {
  addRowToTableData,
  checkTargetQtrIsFuture,
  setPriceLoadDetailsChanged,
  setPriceLoadDetailsTableData
} from '../../store/action';
import {
  dataSourceRadioData,
  FUTURE_QUARTER_ERROR,
  multiPriceSelectionRadioData,
  PACKAGE_SIZE_ERROR,
  PRODUCT_CODE_SIZE,
  TARGET_QUARTER_ERROR,
  VALID_QUARTER_ERROR,
} from '../../utils/constant';
import {
  REQUEST_DRUG_PRICE_LOAD_DETAILS_PRICE_TABLEHEAD,
  REQUEST_DRUG_PRICE_LOAD_DETAILS_URA_TABLEHEAD,
} from '../../utils/tableHead';
import RequestDrugPriceLoadDetailsActionComponent from './RequestDrugPriceLoadDetailsActionComponent';
import RequestDrugPriceLoadDetailsDrugCdComponent from './RequestDrugPriceLoadDetailsDrugCdComponent';
import RequestDrugPriceLoadDetailsTextFieldComponent from './RequestDrugPriceLoadDetailsTextFieldComponent';
import {
  navigateToNextCell,
  onCellFocused,
  tabToNextCell,
} from '../../../../../SharedModules/AgGridUtilities/suppressNavigation';
import ViewHistoryComponent from '../../../../../SharedModules/MicroFrontend/ViewHistoryComponent';
import { getExistingCommentLinkIds } from '../../../../../SharedModules/utilities/commonAPI';
import {
  checkActionAccessByRole,
  isReadOnly as isRead,
} from '../../../../../SharedModules/utilities/utilities';
import { checkQuaterIsValid } from '../RequestDrugPriceLoadManufactureTable';

/* THis Component loads the details in the GRID of DPL */
const RequestDrugPriceLoadDetailsTable = ({
  fullScreen,
  setFullScreen,
  filters,
  referenceData,
  tableData,
  setErrorMessages,
  gridHeight,
  trigerGetComentsExist,
}) => {
  const childRef = useRef(null);
  const dispatch = useDispatch();

  const [showViewHistory, setShowViewHistory] = useState(false);
  const [keyValue, setKeyValue] = useState([]);
  const [hasAccessbyRole, setHasAccessbyRole] = useState(
    checkActionAccessByRole(process.env.REACT_APP_HIDE_ACCESS_ROLES, kcRoles)
  );
  const [isEnablebyRole, setIsEnablebyRole] = useState(
    checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
  );
  const [updatedTableData, setUpdatedTableData] = useState(
    tableData?.map((item) => ({
      ...item,
      ccCommentsExist: 0,
    }))
  );
  const commentsList = useSelector((state) => {
    return state.sharedState.CommentsReducer.commentData;
  });
  const priceLoadDetailsTableData = useSelector(
      (state) => state.sharedState.requestDrugPriceLoad.priceLoadDetailsTableData
    );
  const currentCorrLinkID = useSelector(
      (state) => state.sharedState.requestDrugPriceLoad.currentCorrLinkID
    );
  const { kcRoles } = useSelector((state) => state.sharedState.SharedReducer);
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  useEffect(() => {
    if (kcRoles?.userPrivileges.length > 0) {
      setHasAccessbyRole(
        checkActionAccessByRole(
          process.env.REACT_APP_HIDE_ACCESS_ROLES,
          kcRoles
        )
      );
      setIsEnablebyRole(
        checkActionAccessByRole(process.env.REACT_APP_STATE_ONLY_ROLE, kcRoles)
      );
    }
  }, []);
  useEffect(() => {
    // const corrLinkIdArr = tableData?.map((item) => item.corrLinkId);
    // if (
    //   corrLinkIdArr?.filter((x) => {
    //     return x !== null && x !== 'new';
    //   })?.length > 0
    // ) {
    //   getExistingCommentLinkIds(
    //     corrLinkIdArr?.filter((x) => {
    //       return x !== null && x !== 'new';
    //     })
    //   )
    //     .then((res) => {
    //       const updatedData = tableData?.map((item) => ({
    //         ...item,
    //         ccCommentsExist: res?.includes(item.corrLinkId) ? 1 : 0,
    //       }));
    //       setUpdatedTableData(updatedData);
    //     })
    //     .catch((err) => {});
    // } else {
    //   setUpdatedTableData(tableData);
    // }
    setErrorMessages([])
    setUpdatedTableData(tableData);
  }, [tableData]);

  const validateVal = (allData) => {

    const productCodeError = allData.filter(
      (item) =>
        (!item.productCode || item.productCode.length !== 4) &&
        !item.deleteRecord
    );
    const packageSizeError = allData.filter(
      (item) =>
        (!item.packageSize || item.packageSize.length !== 2) &&
        !item.deleteRecord
    );
    const emptyTargetQuaterError = allData.filter(
      (item) => !item.targetQtr && !item.deleteRecord
    );
    const qtrFomatError = allData.filter(
      (item) => item.targetQtr && !checkQuaterIsValid(item.targetQtr)
    );
    const futureQtrError = allData.filter(
      (item) =>
        item.targetQtr &&
        checkQuaterIsValid(item.targetQtr) &&
        checkTargetQtrIsFuture(item.targetQtr, filters.calcQtr) &&
        !item.deleteRecord
    );
    const localErrorMessages = [];
    if (productCodeError.length > 0) {
      localErrorMessages.push(PRODUCT_CODE_SIZE);
    }
    if (packageSizeError.length > 0) {
      localErrorMessages.push(PACKAGE_SIZE_ERROR);
    }
    if (emptyTargetQuaterError.length > 0) {
      localErrorMessages.push(TARGET_QUARTER_ERROR);
    }
    if (qtrFomatError.length > 0) {
      localErrorMessages.push(VALID_QUARTER_ERROR);
    }
    if (futureQtrError.length > 0) {
      localErrorMessages.push(FUTURE_QUARTER_ERROR);
    }
    setErrorMessages(localErrorMessages);
    if (localErrorMessages.length) return false;
    return true;
  };

  // Adding the new row in the Grid
  const addRow = (tCustom) => {
    setErrorMessages([])
    let data = null;
    if (filters.dataContent === dataSourceRadioData[0].value) {
      const tData = updatedTableData.length ? updatedTableData : tCustom;
      if (!validateVal(tData)) return;
      data = {
        // isAddedFrommUI: true,
        price: '0.000000',
        calcQtr: filters.calcQtr,
        drugCatCd: null,
        lastUpdateDt: getUTCTimeStampMMDDYYYY(new Date()),
        lastUpdateUserId: logInUser,
        targetQtr: filters.calcQtr,
        labelerCode: filters.mfgId,
        productCode: null,
        packageSize: null,
        index: updatedTableData.length,
        ccCommentsExist: 0,
        corrLinkId: 'new',
      };
    } else if (
      filters.multiPriceSelection === multiPriceSelectionRadioData[0].value
    ) {
      const tData = updatedTableData.length ? updatedTableData : tCustom;
      if (!validateVal(tData)) return;
      data = {
        isAddedFromUI: true,
        price: '0.000000',
        bestPrice: '0.000000',
        calcQtr: filters.calcQtr,
        drugCatCd: null,
        lastUpdateDt: getUTCTimeStampMMDDYYYY(new Date()),
        lastUpdateUserId: logInUser,
        targetQtr: filters.calcQtr,
        labelerCode: filters.mfgId,
        productCode: null,
        packageSize: null,
        index: updatedTableData.length,
        ccCommentsExist: 0,
        corrLinkId: 'new',
      };
    } else {
      const tData = updatedTableData.length ? updatedTableData : tCustom;
      if (!validateVal(tData)) return;
      data = {
        isAddedFromUI: true,
        calcUra: '0.000000',
        lastUpdateDt: getUTCTimeStampMMDDYYYY(new Date()),
        lastUpdateUserId: logInUser,
        targetQtr: filters.calcQtr,
        calcQtr: filters.calcQtr,
        labelerCode: filters.mfgId,
        productCode: null,
        packageSize: null,
        index: updatedTableData.length,
        ccCommentsExist: 0,
        corrLinkId: 'new',
      };
    }

    dispatch(addRowToTableData(data, filters.multiPriceSelection));
    dispatch(setPriceLoadDetailsChanged(true));
  };
  const addURA = (tCustom) => {
    setErrorMessages([])
    if (!validateVal(tCustom)) return;
    const data = {
      isAddedFromUI: true,
      calcUra: '0.000000',
      lastUpdateDt: getUTCTimeStampMMDDYYYY(new Date()),
      lastUpdateUserId: logInUser,
      targetQtr: filters.calcQtr,
      calcQtr: filters.calcQtr,
      labelerCode: filters.mfgId,
      productCode: null,
      packageSize: null,
      index: updatedTableData.length,
      ccCommentsExist: 0,
      corrLinkId: 'new',
    };
    dispatch(addRowToTableData(data, 'URA'));
    dispatch(setPriceLoadDetailsChanged(true));
  };
  const handleFullScreenViewClick = () => {
    setErrorMessages([])
    setFullScreen(!fullScreen);
  };
  const handleViewHistory = (gridApi) => {
    const selectedRow = gridApi.getSelectedRows()?.[0];
    if (selectedRow !== undefined) {
      setShowViewHistory(true);
      setKeyValue({
        DRUG_SEQ_NUM: `${selectedRow?.drugSeqNum}`,
        TARGET_QTR: `${selectedRow?.targetQtr}`,
        START_DT: `${selectedRow?.startDt}`,
        PRICE_TYPE_CD: `${selectedRow?.priceTypeCd}`,
      });
    }
  };

  React.useEffect(() => {
    if(Array.isArray(priceLoadDetailsTableData?.priceTableData)){
      let tableData = []
      tableData=priceLoadDetailsTableData?.priceTableData;
      const tempObj =
    tableData &&
    tableData.map((item) => {
        if (
          item.corrLinkId === currentCorrLinkID &&
          commentsList &&
          commentsList.length > 0
        ) {
          item.ccCommentsExist = 1;
        } else if (item.corrLinkId === currentCorrLinkID) {
          item.ccCommentsExist = 0;
        }
        return item;
      });
      priceLoadDetailsTableData.priceTableData=tempObj
       dispatch(setPriceLoadDetailsTableData(priceLoadDetailsTableData));
    }
  }, [commentsList,currentCorrLinkID]);

  return (
    <div className='table-container p-0 eightRecords col-12 no-border mt-4'>
      <Grid
        addTxt={
          checkActionAccessByRole(
            process.env.REACT_APP_HIDE_ACCESS_ROLES,
            kcRoles
          ) && filters?.dataSource === dataSourceRadioData?.[0]?.value
            ? 'Add Row'
            : null
        }
        disableAddAction={!isEnablebyRole}
        addAction={addRow}
        gridHeight={fullScreen ? '100vh' : 350}
        // enterMovesDown
        suppressCellFocus
        onCellFocused={onCellFocused}
        singleClickEdit={false}
        navigateToNextCell={navigateToNextCell}
        // tabToNextCell={tabToNextCell}
        handleFullScreenViewClick={handleFullScreenViewClick}
        exportFile
        fileName='Invoice Drug Price Detail'
        //handleViewHistory={handleViewHistory}
        ref={childRef}
        noRowPadding
        rowData={
          updatedTableData &&
          updatedTableData.filter((item) => !item.deleteRecord)
        }
        defaultCol={{ editable: false }}
        columnDefs={
          filters?.multiPriceSelection ===
          multiPriceSelectionRadioData?.[0]?.value
            ? REQUEST_DRUG_PRICE_LOAD_DETAILS_PRICE_TABLEHEAD(
                filters?.dataContent,
                referenceData,
                filters?.dataSource !== dataSourceRadioData?.[0]?.value
              )
            : REQUEST_DRUG_PRICE_LOAD_DETAILS_URA_TABLEHEAD(
                filters?.dataSource !== dataSourceRadioData?.[0]?.value
              )
        }
        noGlobalSort
        frameworkComponents={{
          textFieldComponent: (props) => (
            <RequestDrugPriceLoadDetailsTextFieldComponent
              {...props}
              onCustomChange={(props) => {
                dispatch(setPriceLoadDetailsChanged(true));
              }}
              addRow={addURA}
              // checkErrors={checkError}
              updatedTableData={tableData}
            />
          ),
          dropDownComponent: (props) => (
            <RequestDrugPriceLoadDetailsDrugCdComponent
              {...props}
              addRow={addRow}
            />
          ),
          ActionCellRender: (props) => (
            <RequestDrugPriceLoadDetailsActionComponent
              {...props}
              disabled={
                filters?.dataSource === dataSourceRadioData?.[2]?.value ||
                filters?.dataSource === dataSourceRadioData?.[1]?.value
              }
              onClick={() => {
                setErrorMessages([])
              }}
            />
          ),
        }}
      />
      {showViewHistory && (
        <ViewHistoryComponent
          setShowViewHistory={setShowViewHistory}
          tableName='PRICE'
          keyValue={keyValue}
        />
      )}
    </div>
  );
};

export default RequestDrugPriceLoadDetailsTable;
